<template>
  <div class="page-shell contact-page">
    <PageBanner
      eyebrow="CONTACT"
      background-image="/page/woshou.jpg"
      :title="text.bannerTitle"
      :subtitle="text.bannerSubtitle"
    />

    <section class="section contact-section">
      <div class="container">
        <div class="contact-layout">
          <aside class="contact-panel">
            <p class="panel-kicker">SERVICE CONTACT</p>
<!--            <h2>{{ $pick(text.panelTitle) }}</h2>-->
            <p class="panel-desc">{{ $pick(text.panelDesc) }}</p>

            <div class="contact-list">
              <article class="contact-row">
                <span class="badge">TEL</span>
                <div>
                  <small>{{ $pick(text.phoneLabel) }}</small>
                  <a :href="phoneLink">+86 15895292999</a>
                  <div>
                    <a :href="phoneLink">+86 19732612158</a>
                  </div>
                </div>
              </article>

              <article class="contact-row qr-row">
                <span class="badge">WX</span>
                <div>
                  <small>{{ $pick(text.wechatLabel) }}</small>
                  <p>{{ $pick(text.wechatHint) }}</p>
                  <div style="display: flex;">
                    <img class="wechat-qr" src="/wechat-im.png" :alt="$pick(text.wechatLabel)" />
                    <img class="wechat-qr" style="margin-left: 16px" src="/WhatsApp.jpg" :alt="$pick(text.wechatLabel)" />
                  </div>
                </div>
              </article>

              <article class="contact-row">
                <span class="badge">@</span>
                <div>
                  <small>{{ $pick(text.emailLabel) }}</small>
                  <a href="mailto:contact@hbtran.com">contact@hbtran.com</a>
                </div>
              </article>

              <article class="contact-row">
                <span class="badge">PIN</span>
                <div>
                  <small>{{ $pick(text.addressLabel) }}</small>
                  <p>{{ addressText }}</p>
                </div>
              </article>
            </div>
          </aside>

          <div class="map-card">
            <img src="/page/contact-banner.jpg" :alt="$pick(text.mapAlt)" />
            <div class="map-shade"></div>
            <div class="map-marker">
              <i class="pin-ripple ripple-one"></i>
              <i class="pin-ripple ripple-two"></i>
              <i class="pin-ripple ripple-three"></i>
              <span></span>
              <strong>{{ $pick(text.companyShort) }}</strong>
              <p>{{ addressText }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import { phoneNumbers } from "../../data/site";

export default {
  name: "ContactPage",
  components: { PageBanner },
  data() {
    return {
      phone: phoneNumbers,
      text: {
        bannerTitle: { "zh-CN": "\u8054\u7cfb\u6211\u4eec", "en-US": "Contact Us" },
        bannerSubtitle: { "zh-CN": "不止变压器，更为您提供整体配电解决方案", "en-US": "More than just transformers, we provide comprehensive power distribution solutions." },
        panelTitle: { "zh-CN": "\u670d\u52a1\u54a8\u8be2", "en-US": "Service Contact" },
        panelDesc: { "zh-CN": "\u5982\u9700\u4ea7\u54c1\u9009\u578b\u3001\u65b9\u6848\u914d\u5957\u6216\u5de5\u7a0b\u670d\u52a1\u652f\u6301\uff0c\u6b22\u8fce\u901a\u8fc7\u4ee5\u4e0b\u65b9\u5f0f\u4e0e\u6211\u4eec\u8054\u7cfb\u3002", "en-US": "For product selection, solution matching or engineering service support, contact us through the channels below." },
        phoneLabel: { "zh-CN": "\u8054\u7cfb\u7535\u8bdd", "en-US": "Phone" },
        wechatLabel: { "zh-CN": "微信 & WhatsApp咨询", "en-US": "WeChat & WhatsApp" },
        wechatHint: { "zh-CN": "微信 & WhatsApp扫码，即时沟通", "en-US": "Scan to contact us on WeChat & WhatsApp." },
        emailLabel: { "zh-CN": "\u90ae\u7bb1", "en-US": "Email" },
        addressLabel: { "zh-CN": "\u5730\u5740", "en-US": "Address" },
        mapAlt: { "zh-CN": "\u516c\u53f8\u5730\u56fe\u4f4d\u7f6e", "en-US": "Company map location" },
        companyShort: { "zh-CN": "\u6c5f\u82cf\u5b8f\u90a6\u53d8\u538b\u5668", "en-US": "Jiangsu Hongbang Transformer" }
      }
    };
  },
  computed: {
    phoneLink() {
      return "tel:" + this.phone.landline.replace(/\s+/g, "");
    },
    addressText() {
      return this.locale === "zh-CN"
        ? "\u6c5f\u82cf\u7701\u5f90\u5dde\u5e02\u94dc\u5c71\u533a\u623f\u6751\u9547\u5de5\u4e1a\u56ed99\u53f7"
        : "No. 99, Fangcun Town Industrial Park, Tongshan District, Xuzhou, Jiangsu";
    }
  }
};
</script>

<style scoped>
.contact-section {
  padding-top: 74px;
  background:
    linear-gradient(180deg, rgba(246, 249, 253, 0.96), #ffffff 52%),
    #ffffff;
}

.contact-layout {
  display: grid;
  grid-template-columns: minmax(360px, 0.42fr) minmax(560px, 0.58fr);
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2eaf4;
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(14, 49, 91, 0.12);
}

.contact-panel {
  position: relative;
  padding: 48px 44px;
  color: #ffffff;
  background:
    radial-gradient(circle at 16% 12%, rgba(68, 163, 255, 0.24), transparent 30%),
    linear-gradient(180deg, rgba(8, 72, 132, 0.96), rgba(5, 48, 94, 0.98)),
    #0b4d91;
}

.contact-panel::before {
  content: "";
  position: absolute;
  inset: auto -90px -120px -80px;
  height: 280px;
  background:
    linear-gradient(18deg, transparent 0 48%, rgba(70, 158, 255, 0.18) 48% 49%, transparent 49%),
    linear-gradient(-22deg, transparent 0 52%, rgba(70, 158, 255, 0.14) 52% 53%, transparent 53%);
  opacity: 0.55;
}

.panel-kicker {
  position: relative;
  margin: 0 0 14px;
  color: #69b9ff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.contact-panel h2 {
  position: relative;
  margin: 0;
  font-size: clamp(32px, 4vw, 44px);
  line-height: 1.15;
}

.contact-panel h2::after {
  content: "";
  display: block;
  width: 56px;
  height: 4px;
  margin-top: 18px;
  background: linear-gradient(90deg, #1f8fff, #77d6ff);
}

.panel-desc {
  position: relative;
  margin: 22px 0 0;
  color: rgba(236, 246, 255, 0.76);
  line-height: 1.9;
}

.contact-list {
  position: relative;
  display: grid;
  gap: 26px;
  margin-top: 42px;
}

.contact-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.badge {
  display: inline-grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  color: #ffffff;
  background: linear-gradient(135deg, #146bd4, #39a0ff);
  box-shadow: 0 14px 28px rgba(0, 13, 35, 0.22);
  font-size: 13px;
  font-weight: 800;
}

.contact-row small {
  display: block;
  margin-bottom: 6px;
  color: rgba(236, 246, 255, 0.72);
  font-size: 14px;
  font-weight: 700;
}

.contact-row a,
.contact-row p {
  margin: 0;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.55;
  word-break: break-word;
}

.qr-row p {
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  font-weight: 600;
}

.wechat-qr {
  width: 156px;
  height: 156px;
  padding: 7px;
  object-fit: contain;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(0, 13, 35, 0.24);
}

.map-card {
  position: relative;
  min-height: 640px;
  overflow: hidden;
  background: #eef4fb;
}

.map-card img {
  width: 100%;
  height: 100%;
  min-height: 640px;
  object-fit: cover;
  filter: saturate(0.78) brightness(1.08);
  transform: scale(1.04);
}

.map-shade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.52)),
    rgba(236, 245, 254, 0.2);
}

.map-marker {
  position: absolute;
  left: 50%;
  top: 52%;
  width: min(320px, calc(100% - 56px));
  padding: 20px 22px;
  color: #33465d;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(212, 224, 238, 0.9);
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(53, 86, 126, 0.18);
  transform: translate(-50%, 16px);
}

.map-marker span {
  position: absolute;
  left: 50%;
  top: -72px;
  z-index: 3;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #146bd4, #49a7ff);
  border-radius: 50% 50% 50% 0;
  box-shadow: 0 14px 24px rgba(20, 107, 212, 0.28);
  transform: translateX(-50%) rotate(-45deg);
}

.map-marker span::after {
  content: "";
  position: absolute;
  inset: 14px;
  border-radius: 50%;
  background: #e8f4ff;
}

.pin-ripple {
  position: absolute;
  left: 50%;
  top: -48px;
  z-index: 1;
  width: 880px;
  height: 880px;
  border: 0;
  border-radius: 50%;
  background: rgba(42, 139, 236, 0.12);
  transform: translate(-50%, -50%);
  pointer-events: none;
  animation: pinRipple 4.2s ease-out infinite;
}

.ripple-two {
  width: 600px;
  height: 600px;
  background: rgba(42, 139, 236, 0.16);
  animation-delay: 0.8s;
}

.ripple-three {
  width: 330px;
  height: 330px;
  background: rgba(42, 139, 236, 0.2);
  animation-delay: 1.6s;
}

@keyframes pinRipple {
  0% {
    opacity: 0.45;
    transform: translate(-50%, -50%) scale(0.72);
  }

  72% {
    opacity: 0.24;
  }

  100% {
    opacity: 0.08;
    transform: translate(-50%, -50%) scale(1.04);
  }
}

.map-marker strong {
  display: block;
  margin-bottom: 8px;
  color: var(--brand-blue-deep);
  font-size: 18px;
}

.map-marker p {
  margin: 0;
  color: #627086;
  font-size: 16px;
  line-height: 1.7;
}

@media (max-width: 1100px) {
  .contact-layout {
    grid-template-columns: 1fr;
  }

  .map-card,
  .map-card img {
    min-height: 460px;
  }
}

@media (max-width: 640px) {
  .contact-section {
    padding-top: 40px;
  }

  .contact-panel {
    padding: 32px 22px;
  }

  .contact-list {
    gap: 22px;
  }

  .contact-row {
    grid-template-columns: 46px minmax(0, 1fr);
    gap: 14px;
  }

  .badge {
    width: 42px;
    height: 42px;
    font-size: 11px;
  }

  .contact-row a,
  .contact-row p {
    font-size: 17px;
  }

  .wechat-qr {
    width: 138px;
    height: 138px;
  }

  .map-card,
  .map-card img {
    min-height: 360px;
  }

  .map-marker {
    top: 48%;
    width: calc(100% - 34px);
    padding: 16px 18px;
  }
}
</style>
